import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@shared/components/ui/button';
import type { ThreePlReportDefinition } from '../../models/reports';

interface ReportListRowProps {
  report: ThreePlReportDefinition;
  isLast: boolean;
  isGenerating: boolean;
  onGenerate: (report: ThreePlReportDefinition) => void;
}

export const ReportListRow = memo(function ReportListRow({
  report,
  isLast,
  isGenerating,
  onGenerate,
}: ReportListRowProps) {
  const { t } = useTranslation('threePlExcelReportsModule');

  return (
    <div
      className={`grid grid-cols-1 items-start gap-3 px-4 py-4 sm:grid-cols-[1fr_auto] sm:items-center sm:py-3.5 ${
        isLast ? '' : 'border-b border-border'
      }`}
      data-testid={`three-pl-report-row-${report.id}`}
    >
      <div className="min-w-0 space-y-1">
        <p className="text-sm font-medium text-foreground">{t(report.titleKey)}</p>
        <p className="text-sm text-muted-foreground">{t(report.descriptionKey)}</p>
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        className="shrink-0 gap-2 transition-colors"
        onClick={() => onGenerate(report)}
        disabled={isGenerating}
        data-testid={`three-pl-report-generate-${report.id}`}
      >
        <FontAwesomeIcon icon={faFileArrowDown} className="h-4 w-4" />
        {t('actions.generate')}
      </Button>
    </div>
  );
});
